import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Assessment, Delivery, Reports } from '../app.urls';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
  public PatientListData = new BehaviorSubject<any>(false);
  public getPatientListData = this.PatientListData.asObservable();
  public patientDataFromAssessment = new BehaviorSubject<any>(false);
  public PatientDetails = new BehaviorSubject<any>(false);
  public getBasicPatientDetail = this.PatientDetails.asObservable();
  public getpatientDataFromAssessment = this.patientDataFromAssessment.asObservable();
  public confirmOtp = new BehaviorSubject<any>(false);
  public getconfirmOtp = this.confirmOtp.asObservable();
  constructor(public http: HttpClient) { }

  getPatientList(collectionId) {
    return this.http.get<any>(Assessment.patientAPI + `?collectionId=${collectionId}`);
  }

  submitPatientDetails(payload: any, collectionId) {
    let payload1 = {...payload, 'collectionId': collectionId};
    return this.http.post<any>(Assessment.patientAPI, payload1);
  }

  edittPatientDetails(payload: any, collectionId) {
    let payload1 = {...payload, 'collectionId': collectionId};
    return this.http.put<any>(Assessment.patientAPI, payload1);
  }

  searchPatient(patientName, phone, assessmentStatus, collectionId) {
    return this.http.get<any>(Assessment.patientAPI + `?collectionId=${collectionId}&patientname=${patientName}&phone=${phone}&assessmentstatusid=${assessmentStatus}`);
  }

  getAssessmentStatus() {
    return this.http.get<any>(Assessment.assessmentstatusmaster);
  }

  getPatientDetails(patientId) {
    return this.http.get<any>(Assessment.patientAPI + `/${patientId}`);
  }

  getTestDeliveryPatientDetails(patientId) {
    return this.http.get<any>(Delivery.PatientDetails + `/${patientId}`);
  }

  getPatientHeaderDetails(patientId, collectionId) {
    return this.http.get<any>(Assessment.patientheaderdetails + `/${patientId}?collectionId=${collectionId}`);
  }

  getPatientAssessments(patientId, collectionId) {
    return this.http.get<any>(Assessment.patientassessments + `/${patientId}?collectionId=${collectionId}`);
  }

  getSearchPatientAssessments(patientId, assessmentName, assessmentStatus, assessmentType, collectionId) {
    return this.http.get<any>(Assessment.patientassessments + `/${patientId}?collectionId=${collectionId}&assessmentname=${assessmentName}&assessmentstatusid=${assessmentStatus}&assessmenttypeid=${assessmentType}`);
  }

  GetAssessmentTypeMaster() {
    return this.http.get<any>(Assessment.AssessmentTypeMaster);
  }

  dashboardDetails(collectionId, Center?, doctorid?, fromDate?, toDate?) {
    return this.http.get<any>(Assessment.dashboardDetails + `?collectionId=${collectionId}&fromDate=${fromDate}&toDate=${toDate}&center=${Center}&doctorId=${doctorid}`);
  }

  getReportPatientList(collectionId, patientName, phone, patientCategory, center?, doctorId?, patientid?, assessmentStatusId?) {
    return this.http.get<any>(Assessment.patientList + `?collectionId=${collectionId}&patientName=${patientName}&phone=${phone}&patientCategory=${patientCategory}&center=${center}&doctorId=${doctorId}&patientId=${patientid}&assessmentstatusId=${assessmentStatusId}`);
  }

  getReportPatientAssessmentList(collectionId, patientId,assessmentName, assessmentStatus, assessmentType) {
    return this.http.get<any>(Assessment.patientAssessmentList + `?collectionId=${collectionId}&patientId=${patientId}&assessmentName=${assessmentName}&assessmentStatus=${assessmentStatus}&assessmentType=${assessmentType}`);
  }

  getPatientAssessmentTestDetail(scheduleId, patientId) {
    return this.http.get<any>(Assessment.PatientAssessmentTestDetail + `?scheduleId=${scheduleId}&patientId=${patientId}`)
  }

  getPatientCategories() {
    return this.http.get<any>(Assessment.patientCategory)
  }

  submitConsent(examineeId) {
    return this.http.post<any>(Delivery.consent, examineeId )

  }

  submitRemark(payload) {
    return this.http.put<any>(Reports.submitRemark, payload);
  }

  getCenterList(collectionId) {
    return this.http.get<any>(Reports.centerList + `?collectionId=${collectionId}`);
  }

  getDoctors(collectionId) {
    return this.http.get<any>(Reports.doctorList + `?collectionId=${collectionId}`)
  }

  getPatientListDropdown(collectionId) {
    return this.http.get<any>(Reports.patientList + `?collectionId=${collectionId}`)
  }

  sendAssessmentUrl(patientId, assessmentname, AssessmentStatusId, AssessmentTypeId, scheduleCode?, collectionId?) {
    let payload = {
      "patientid": patientId,
      "assessmentname": assessmentname,
      "schedulecode": scheduleCode,
      "AssessmentStatusId": AssessmentStatusId,
      "AssessmentTypeId": AssessmentTypeId,
      "CollectionId": collectionId
    }
    return this.http.post<any>(Assessment.sendassessmenturl, payload)
  }

  verifyOtp(patientuuid, otpcode) {
    let payload = {
      "patientuuid": patientuuid,
      "otpcode": otpcode
    }
    return this.http.post<any>(Assessment.verifyotp, payload);
  }

  resendOtp(patientuuid) {
    return this.http.post<any>(Assessment.resendotp + `/${patientuuid}`, '')
  }

  getCountryCodes() {
    return this.http.get<any>(`assets/config/CountryCodes.json`);
  }

  getCountry() {
    return this.http.get<any>(`assets/config/Countrys.json`);
  }
}
